import { AppBox } from "../../../../../commons/components";
import { IFootballTeamManager } from "../../../../../commons/models/football/interface/i-football-team-manager";
import { toTitleCase } from "../../../../../commons/utilities/string-utils";

interface TeamManagerRemoveProps {
  teamManager: IFootballTeamManager;
}
export default function TeamManagerRemove({ teamManager }: TeamManagerRemoveProps) {
  return (
    <AppBox displayBlock>
      Do you want to remove <strong>“{toTitleCase(teamManager?.fullName)}” </strong> from the team? Once you remove the
      manager, the action cannot be undone.
    </AppBox>
  );
}
